<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Github, ExternalLink, Sparkles } from 'lucide-vue-next'

import BaseIcon from '@/components/BaseIcon.vue'
import { useResume } from '@/composables/useResume'

const { content } = useResume()
const { t } = useI18n()
</script>

<template>
  <section id="projects">
    <div class="wrap">
      <div class="sec-head reveal">
        <div class="eyebrow"><span class="eyebrow-idx">03 /</span> {{ content.sectionTitles.projects }}</div>
        <h2 class="sec-title">{{ t('sections.projectsTitle') }}</h2>
        <p class="sec-sub">{{ content.sectionTitles.projectsSub }}</p>
      </div>

      <div class="proj-grid">
        <div
          v-for="(project, i) in content.projects"
          :key="i"
          class="proj-card glass reveal"
          :class="`d${(i % 3) + 1}`"
        >
          <div class="proj-top">
            <div class="proj-head">
              <div class="proj-name">{{ project.name }}</div>
              <div class="proj-url">{{ project.url }}</div>
            </div>
            <span class="proj-team">{{ project.team }}</span>
          </div>
          <p class="proj-desc">{{ project.desc }}</p>
          <div class="proj-tags">
            <span v-for="(tag, j) in project.tags" :key="j" class="tag">{{ tag }}</span>
          </div>
        </div>
      </div>

      <div class="sec-head reveal" style="margin-top: 64px; margin-bottom: 0">
        <div class="eyebrow"><BaseIcon :icon="Sparkles" :size="13" />{{ content.sectionTitles.code }}</div>
      </div>
      <div class="code-grid">
        <div
          v-for="(sample, i) in content.code"
          :key="i"
          class="code-card glass reveal"
          :class="`d${i + 1}`"
        >
          <div>
            <div class="code-name">{{ sample.name }}</div>
            <div class="code-stack">{{ sample.stack }}</div>
            <div v-if="sample.note" class="code-note">{{ sample.note }}</div>
          </div>
          <div class="code-links">
            <a
              v-for="([label, url], j) in sample.links"
              :key="j"
              class="code-link"
              :href="url"
              target="_blank"
              rel="noopener"
            >
              <BaseIcon :icon="label === 'GitHub' ? Github : ExternalLink" :size="14" />{{ label }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
